import { createContext } from "react";

export const PlansContext = createContext<{ isPos: boolean }>({ isPos: false });
